<div class="flex flex-col">

  <h1 class="text-lg">Make Call</h1>

  <form class="flex flex-col"
    [formGroup]="form"
    (ngSubmit)="submit()">
  
    <app-select-phone-number (selected)="onFromSelected($event)" type="twilio">

      <mat-form-field class="flex grow">
    
        <mat-label>From:</mat-label>
  
        <input type="tel"
          formControlName="from"
          matInput>

        <mat-hint>{{fromHint()}}</mat-hint>
  
        <mat-error>This field is required.</mat-error>
  
      </mat-form-field>
  
    </app-select-phone-number>

    <app-select-phone-number [from]="from()" (selected)="onToSelected($event)" type="contacts">
      
      <mat-form-field>

        <mat-label>To:</mat-label>

        <input type="tel"
          formControlName="to"
          matInput>

        <mat-hint>{{toHint()}}</mat-hint>

        <mat-error>This field is required.</mat-error>

      </mat-form-field>

    </app-select-phone-number>

    <app-select-phone-number (selected)="onViaSelected($event)" type="via">

      <mat-form-field>

        <mat-label>Via:</mat-label>
  
        <input type="tel"
          formControlName="via"
          matInput>

        <mat-hint>{{viaHint()}}</mat-hint>
  
        <mat-error>This field is required.</mat-error>
  
      </mat-form-field>

    </app-select-phone-number>

    <mat-slide-toggle formControlName="record">Record This Call</mat-slide-toggle>

    <div class="flex flex-row justify-between">

      <span>&nbsp;</span>

      <mat-spinner *ngIf="processing()" diameter="30"></mat-spinner>

      <button type="submit" color="primary"
        [disabled]="form.invalid || processing()"
        mat-raised-button>Make Call</button>

    </div>

  </form>

</div>
